import '@webcomponents/webcomponentsjs'
import 'core-js/modules/es.global-this'
import 'whatwg-fetch'
import { DebugInfo, NamespaceFunction, NamespaceInfo } from './elements/debug-info'
import { ServerClock } from './elements/server-clock'
import { AppVersion } from './elements/app-version'
import { FormLayout, FormRow } from './elements/form-element'
import { LoadingCurtain } from './elements/loading-curtain'
import { MenuContext, WorkspaceMenu } from './elements/menu-context'
import { MenuItem } from './elements/menu-item'
import { ModuleHeader } from './elements/module-header'
import { NotificationBoard } from './elements/notifcation-board'
import { MessageTicker } from './elements/message-ticker'
import { KryptonTabs } from './elements/krypton-tabs'
import { NotificationElement } from './elements/notification-element'
import { PageElement } from './elements/page-element'
import { PageManager } from './elements/page-manager'
import { PageNav } from './elements/page-nav'
import { SearchMenu } from './elements/search-menu'
import { SlideElement } from './elements/slider-element'
import { SliderCanvas } from './elements/slider-canvas'
import { KryptonDialog } from './elements/krypton-dialog'
import { TableBody, TableCell, TableElement, TableHeader, TableRow } from './elements/table-element'
import { KryptonApp } from './krypton-app'
import { PublicApp } from './external/public-app'
import './modules/forms'

import { BaseWidget } from './elements/landing-page/base-widget'
import { LandingPageContentLoader } from './elements/landing-page/landing-page-content-loader'
import { QuickLinkWidget } from './elements/landing-page/quicklink-widget'
import { WorkspaceWidget } from './elements/landing-page/workspace-widget'
import { DataInsightsWidget } from './elements/landing-page/data-insights-widget'
import { InfoWidget } from './elements/landing-page/info-widget'
import { QuickLinksDefault } from './elements/landing-page/default-widgets/quicklinks-default'
import { WorkspaceDefault } from './elements/landing-page/default-widgets/workspace-default'
import { MfaWorkspaceDefault } from './elements/landing-page/default-widgets/mfa-workspace-default'
import { InformationalDefault } from './elements/landing-page/default-widgets/informational-default'
import { PublicAppHeader } from './external/public-app-header'
import { PublicAppFooter } from './external/public-app-footer'
import { PublicAppContentLoader } from './external/public-app-content-loader'
import { PublicAppPanel } from './external/public-app-panel'
import { PublicAppTabContainer } from './external/public-app-tab-container'
import { PublicAppWidget } from './external/public-app-widget'
import { PublicAppTablePaginator } from './external/public-app-table-paginator'
import { PublicAppNavigationMenu } from './external/public-app-navigation-menu'

customElements.define("debug-info", DebugInfo);
customElements.define("namespace-info", NamespaceInfo);
customElements.define("namespace-function", NamespaceFunction);
customElements.define("server-clock", ServerClock);
customElements.define("app-version", AppVersion);
customElements.define("f-layout", FormLayout);
customElements.define("f-row", FormRow);
customElements.define("loading-curtain", LoadingCurtain);
customElements.define("menu-context", MenuContext);
customElements.define("workspace-menu", WorkspaceMenu);
customElements.define("menu-item", MenuItem);
customElements.define("module-header", ModuleHeader);
customElements.define("message-ticker", MessageTicker);
customElements.define("krypton-tabs", KryptonTabs);
customElements.define("notification-board", NotificationBoard);
customElements.define("notification-element", NotificationElement);
customElements.define("page-element", PageElement);
customElements.define("page-manager", PageManager);
customElements.define("page-nav", PageNav);
customElements.define("search-menu", SearchMenu);
customElements.define("slider-element", SlideElement);
customElements.define("slider-canvas", SliderCanvas);
customElements.define("krypton-dialog", KryptonDialog);
customElements.define("t-element", TableElement);
customElements.define("t-head", TableHeader);
customElements.define("t-body", TableBody);
customElements.define("t-row", TableRow);
customElements.define("t-cell", TableCell);
customElements.define("krypton-app", KryptonApp);

customElements.define("base-widget", BaseWidget);
customElements.define("landing-page-content-loader", LandingPageContentLoader);
customElements.define("quicklink-widget", QuickLinkWidget);
customElements.define("workspace-widget", WorkspaceWidget);
customElements.define("info-widget", InfoWidget);
customElements.define("data-insights-widget", DataInsightsWidget);

customElements.define("quicklinks-default", QuickLinksDefault);
customElements.define("workspace-default", WorkspaceDefault);
customElements.define("mfa-workspace-default", MfaWorkspaceDefault);
customElements.define("informational-default", InformationalDefault);
customElements.define("public-app", PublicApp);
customElements.define("public-app-header", PublicAppHeader);
customElements.define("public-app-footer", PublicAppFooter);
customElements.define("public-app-content-loader", PublicAppContentLoader);
customElements.define("public-app-tab-container", PublicAppTabContainer);
customElements.define("public-app-panel", PublicAppPanel);
customElements.define("public-app-widget", PublicAppWidget);
customElements.define("public-app-table-paginator", PublicAppTablePaginator);
customElements.define("public-app-navigation-menu", PublicAppNavigationMenu);


let kryptonApp;
window["kryptonApp"] = () => kryptonApp ? kryptonApp : kryptonApp = document.getElementById("krypton-app");

let publicApp;
window["publicApp"] = () => publicApp ? publicApp : publicApp = document.getElementById("public-app");
//Noise.simulateNetwork(100, 500);


//--UrlResolver test
// import { UrlResolver } from './modules/urlResolver'
// const TEST_URLS = [
//     "https://scgenvoy.sempra.com/WebDispatch",
//     "http://scgenvoy.sempra.com/thisShouldHaeveContext/and/here",
//     "scgenvoy.sempra.com/WebDispatch/Login",
//     "socalgasenvoy.sempra.com",
//     "s-dfsdfs.sempra.com/logout",
//     "WebDispatch/hello",
//     "/WebDispatch/no?yes=1"
// ];
// for (let i = 0; i < TEST_URLS.length; i++) {
//     console.log(UrlResolver.RELATIVE.resolve(TEST_URLS[i]));
// }
